import { useEffect, useState } from 'react'
import useFirstRender from '../../hooks/FirstRender';
import LoadMore from '../../components/common/LoadMore';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useApiProgress } from '../../hooks/ApiProgress';
import readXlsxFile, { readSheetNames } from 'read-excel-file';
import { toast } from 'react-toastify';
import Input from '../../components/Input';
import { AiFillDelete, AiFillEdit } from 'react-icons/ai';
import Spinner from '../../components/Spinner';
import Button from '../../components/Button';
import { GoPlus } from 'react-icons/go';
import { RiFileExcel2Fill } from 'react-icons/ri';
import { ROLL_API, deleteRoll, downloadRollExcelFile, getPageRolls, getSumRolls, uploadStockExcelFile } from '../../api/rollApi';
import { pageModel } from '../../utils/model';
import { PRODUCT_PATH, getPageProducts } from '../../api/productApi';
import { RxCross1 } from 'react-icons/rx';
import { FaCloudDownloadAlt, FaPrint } from "react-icons/fa";
import BarcodePrinter from '../../components/barcode/BarcodePrinter';
import { MdClear } from "react-icons/md";
import { setRollSearchParamsAction } from '../../redux/feature/searchParamsSlice';
import { LOCATION_PATH, getPageLocations } from '../../api/locationApi';
import LocationPicker from '../../components/location/LocationPicker';
import { PRODUCT_COLLECTION_PATH, getPageProductCollections } from '../../api/productCollectionApi';
import CollectionPicker from '../../components/product/CollectionPicker';
import CollectionLabel from '../../components/product/CollectionLabel';
import { COLOR_PATH, getPageColors } from '../../api/colorApi';
import ColorPicker from '../../components/color/ColorPicker';
import { formatNumber } from '../../utils/functions';
import DeleteModal from '../../components/DeleteModal';

const StockListPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const isFirstRender = useFirstRender()
    const nav = useNavigate()
    const dispatch = useDispatch()
    const [rollPage, setRollPage] = useState(pageModel)
    const pendingApiCall = useApiProgress('get', `${ROLL_API}/page`, false)
    const pendingApiCallDelete = useApiProgress('delete', `${ROLL_API}`, false)
    const searchParams = useSelector(state => state.searchParams.roll)

    const [isOpen, setIsOpen] = useState(false)
    const [deleteId, setDeleteId] = useState(undefined)
    const [searchTimer, setSearchTimer] = useState();

    const [productPage, setProductPage] = useState({
        content: []
    });
    const [locationPage, setLocationPage] = useState({
        content: []
    });
    const [collectionPage, setCollectionPage] = useState({
        content: []
    });
    const [colorPage, setColorPage] = useState({
        content: []
    });
    const [searchTimerProduct, setSearchTimerProduct] = useState();
    const [searchTimerLocation, setSearchTimerLocation] = useState();
    const [searchTimerCollection, setSearchTimerCollection] = useState();
    const [searchTimerColor, setSearchTimerColor] = useState();
    const [collectionQuery, setCollectionQuery] = useState('')
    const [colorQuery, setColorQuery] = useState('')
    const pendingApiCallCollection = useApiProgress('get', `${PRODUCT_COLLECTION_PATH}/page`, false)
    const pendingApiCallProduct = useApiProgress('get', `${PRODUCT_PATH}/page`, false)
    const pendingApiCallColor = useApiProgress('get', `${COLOR_PATH}/page`, false)
    const [productQuery, setProductQuery] = useState('')
    const [sum, setSum] = useState()

    const [selectedRolls, setSelectedRolls] = useState([])
    const [locationQuery, setLocationQuery] = useState('')
    const pendingApiCallLocation = useApiProgress('get', `${LOCATION_PATH}/page`, false)

    const loadRolls = (params) => {
        !pendingApiCall &&
            getPageRolls(params)
                .then(res => {
                    setRollPage(prevState => ({ ...res.data, content: [...prevState.content, ...res.data.content] }))
                })
    }

    const loadSum = (params) => {
        getSumRolls(params)
            .then(res => { setSum(res.data) })
    }

    const searchingLocation = async (params) => {
        if (searchTimerLocation) clearTimeout(searchTimerLocation);
        let timer = setTimeout(() => {
            getPageLocations(params)
                .then(res => {
                    setLocationPage(res.data)
                })
        }, 500);
        setSearchTimerLocation(timer);
    }

    const searchingColor = async (params) => {
        if (searchTimerColor) clearTimeout(searchTimerColor);
        let timer = setTimeout(() => {
            getPageColors(params)
                .then(res => {
                    setColorPage(res.data)
                })
        }, 500);
        setSearchTimerColor(timer);
    }

    const searchingCollection = async (params) => {
        if (searchTimerCollection) clearTimeout(searchTimerCollection);
        let timer = setTimeout(() => {
            getPageProductCollections(params)
                .then(res => {
                    setCollectionPage(res.data)
                })
        }, 500);
        setSearchTimerCollection(timer);
    }

    const rollFilters = () => ({ ...searchParams, collectionId: searchParams.collection?.id, colorId: searchParams.color?.id, locationId: searchParams.location?.id })

    const onLoadMore = () => {
        if (!rollPage.last) {
            loadRolls({ ...rollFilters(), page: rollPage.number + 1 })
        }
    }

    const searching = async (params) => {
        if (searchTimer) clearTimeout(searchTimer);
        let timer = setTimeout(() => {
            getPageRolls(params)
                .then(res => {
                    setRollPage(res.data)
                })
        }, 500);
        setSearchTimer(timer);
    }

    const searchingProduct = async (params) => {
        if (searchTimerProduct) clearTimeout(searchTimerProduct);
        let timer = setTimeout(() => {
            getPageProducts(params)
                .then(res => {
                    setProductPage(res.data)
                })
        }, 500);
        setSearchTimerProduct(timer);
    }

    const onClickLoadMoreLocation = () => {
        if (!locationPage.last) {
            loadLocations({ search: locationQuery, lastId: locationPage.content[locationPage.content.length - 1]?.id })
        }
    }

    const onClickLoadMoreColor = () => {
        if (!colorPage.last) {
            loadColors({ search: colorQuery, lastId: colorPage.content[colorPage.content.length - 1]?.id })
        }
    }

    const onClickLoadMoreProduct = () => {
        if (!productPage.last) {
            loadProducts({ search: productQuery, lastId: productPage.content[productPage.content.length - 1]?.id })
        }
    }

    const onClickLoadMoreCollection = () => {
        if (!collectionPage.last) {
            loadCollections({ search: collectionQuery, lastId: collectionPage.content[collectionPage.content.length - 1]?.id })
        }
    }

    const loadProducts = (params) => {
        !pendingApiCallProduct &&
            getPageProducts(params)
                .then(res => {
                    setProductPage(prevState => ({ ...res.data, content: prevState.content.concat(res.data.content) }))
                })
    }

    const loadLocations = (params) => {
        !pendingApiCallLocation &&
            getPageLocations(params)
                .then(res => {
                    setLocationPage(prevState => ({ ...res.data, content: prevState.content.concat(res.data.content) }))
                })
    }

    const loadColors = (params) => {
        !pendingApiCallColor &&
            getPageColors(params)
                .then(res => {
                    setColorPage(prevState => ({ ...res.data, content: prevState.content.concat(res.data.content) }))
                })
    }

    const loadCollections = (params) => {
        !pendingApiCallCollection &&
            getPageProductCollections(params)
                .then(res => {
                    setCollectionPage(prevState => ({ ...res.data, content: prevState.content.concat(res.data.content) }))
                })
    }

    useEffect(() => {
        !isFirstRender && searchingLocation({ search: locationQuery })
    }, [locationQuery])

    useEffect(() => {
        !isFirstRender && searchingProduct({ search: productQuery })
    }, [productQuery])

    useEffect(() => {
        !isFirstRender && searchingCollection({ search: collectionQuery })
    }, [collectionQuery])

    useEffect(() => {
        !isFirstRender && searchingColor({ search: colorQuery })
    }, [colorQuery])

    useEffect(() => {
        loadProducts({ size: 20 })
        loadRolls({ ...rollFilters(), page: 0 })
        loadLocations({ size: 20 })
        loadCollections({ size: 20 })
        loadColors({ size: 20 })
        loadSum(rollFilters())
    }, [])

    useEffect(() => {
        !isFirstRender && searching({ ...rollFilters(), page: 0 })
        loadSum(rollFilters())
    }, [searchParams])

    const onClickSelectBarcode = (checked, roll) => {
        if (checked) {
            setSelectedRolls(prevState => ([...prevState, roll]))
        } else {
            setSelectedRolls(prevState => prevState.filter(p => p.id !== roll.id))
        }
    }

    const onClickSelectAllRolls = () => {
        if (selectedRolls.length > 0) {
            setSelectedRolls([])
        } else {
            setSelectedRolls(rollPage.content)
        }

    }

    const uploadExcelFile = async (event) => {
        const file = event.target.files[0];
        if (!Boolean(file)) return;
        const sheets = await readSheetNames(file);
        let rows;
        for (const sheet of sheets) {
            rows = await readXlsxFile(file, { sheet });
            rows.shift();
        }
        const items = []
        for (const row of rows) {
            items.push({
                upc: row[0],
                productCode: row[1],
                variationCode: row[2],
                boilerCode: row[3],
                locationCode: row[4],
                quantity: row[5],
                restQuantity: row[6],
                unitCost: row[7],
                date: row[8],
            })
        }
        uploadStockExcelFile(items)
            .then(res => {
                toast.success("Kayıtlar güncellendi")
            }).catch(err => {
                toast.error(err.response.data.message)
            })
    }

    const downloadExcelFile = () => {
        downloadRollExcelFile(rollFilters()).then(res => {
            const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${searchParams.collection ? "Ürün Kodu;" + searchParams.collection.code : ""}-${searchParams.color ? 'Renk Kodu;' + searchParams.color.code : ""}` + '.xlsx';
            a.click();
            window.URL.revokeObjectURL(url);
        }).catch(err => {
            toast.error('Dosya indirilirken hata oluştu!')
        })
    }

    const onClickDeleteRoll = () => {
        deleteRoll(deleteId)
            .then(res => {
                setRollPage(prev => ({ ...prev, content: prev.content.filter(p => p.id !== deleteId) }))
                toast.success('Silindi')
                setDeleteId()
                setIsOpen(false)
            }).catch(err => {
                toast.error('Ürün kullanımda!')
            })
    }

    return (
        <div>
            <div className='mb-1 border-b border-zinc-300'>
                <label className='text-2xl uppercase'>
                    Stok
                </label>
            </div>
            <div className='flex gap-x-2 py-1 sticky top-0 bg-zinc-50'>
                <Button
                    text={<label className='flex items-center gap-x-1'><GoPlus />Yeni Stok</label>}
                    variant='green'
                    onClick={() => nav('/stock/add')}
                />
                <label
                    className='bg-emerald-700 hover:bg-emerald-800 disabled:bg-emerald-500 flex items-center gap-x-1 px-2 py-1 text-white text-md rounded-sm'
                    htmlFor='excel-download'
                    onClick={downloadExcelFile}
                >
                    <FaCloudDownloadAlt />
                    <span>Excel İndir</span>
                </label>
                <label
                    className='bg-emerald-700 hover:bg-emerald-800 disabled:bg-emerald-500 flex items-center gap-x-1 px-2 py-1 text-white text-md rounded-sm'
                    htmlFor='excel-upload'
                >
                    <RiFileExcel2Fill />
                    <span> Excel Yükle</span>
                </label>
                <input className='hidden' id='excel-upload' type='file' accept='.xls, .xlsx' onChange={e => uploadExcelFile(e)} />
            </div>

            <div className='flex justify-between gap-x-2 py-1 sticky top-10 bg-zinc-50'>
                <Button
                    text={<label className='flex items-center gap-x-1'><FaPrint /><BarcodePrinter barcodes={selectedRolls} /></label>}
                    variant='green'
                    //onClick={onClickPrintBarcodes}
                    disabled={selectedRolls.length === 0}
                />
                <div className='flex gap-x-2 items-center text-sm'>
                    <input name='hasMore' type='checkbox' id='hasMore' onChange={e => dispatch(setRollSearchParamsAction({ key: e.target.name, value: !e.target.checked }))} />
                    <label htmlFor='hasMore'>Tükenenleri göster</label>
                </div>
            </div>
            <div className='flex items-center sticky top-20 bg-zinc-50'>
                <label className='text-xs'>{selectedRolls.length > 0 && `${selectedRolls.length} adet seçim yaptınız`} &nbsp;</label>
                {selectedRolls.length > 0 &&
                    <MdClear
                        className='hover:scale-125 duration-150 cursor-pointer hover:text-red-700'
                        onClick={() => setSelectedRolls([])}
                    />
                }
            </div>
            <table className='w-full text-left text-zinc-900 mb-10'>
                <thead className='text-xs uppercase tracking-wide sticky top-20 bg-zinc-50'>
                    <tr>
                        <th className='w-1/24'>Seçili</th>
                        <th className='w-1/12'>Barkod</th>
                        <th className='w-2/12'>
                            <div className='flex justify-between'>
                                <div className='flex gap-x-2'>
                                    <span>Ürün</span>
                                    <span className='mr-2'>
                                        {pendingApiCallCollection && <Spinner />}
                                    </span>
                                </div>
                                {
                                    searchParams.collection &&
                                    <span onClick={() => dispatch(setRollSearchParamsAction({ key: 'collection', value: null }))} ><RxCross1 /></span>
                                }
                            </div>
                        </th>
                        <th className='w-2/12'>
                            <div className='flex justify-between'>
                                <div className='flex gap-x-2'>
                                    <span>Renk</span>
                                    <span className='mr-2'>
                                        {pendingApiCallColor && <Spinner />}
                                    </span>
                                </div>
                                {
                                    searchParams.color &&
                                    <span onClick={() => dispatch(setRollSearchParamsAction({ key: 'color', value: null }))} ><RxCross1 /></span>
                                }
                            </div>
                        </th>
                        <th className='w-1/12'>
                            <div className='flex justify-between'>
                                <div className='flex gap-x-2'>
                                    <span>Lokasyon</span>
                                    <span className='mr-2'>
                                        {pendingApiCallLocation && <Spinner />}
                                    </span>
                                </div>
                                {
                                    searchParams.location &&
                                    <span onClick={() => dispatch(setRollSearchParamsAction({ key: 'location', value: null }))} ><RxCross1 /></span>
                                }
                            </div>
                        </th>
                        <th className='w-3/12'>Kazan No</th>
                        <th className='w-1/12'>Miktar (m)</th>
                        <th className='w-1/12'>Kalan (m)</th>
                        {/* <th className='w-1/12'>Birim Maliyet (USD/m)</th> */}
                        <th className='w-1/24'>Aksiyon</th>

                    </tr>
                </thead>
                <tbody>
                    <tr className='border-b items-center sticky top-24 bg-zinc-50'>
                        <td> <input
                            type='checkbox'
                            onChange={() => {
                                onClickSelectAllRolls()
                            }}
                            checked={selectedRolls.length > 0}

                        /></td>
                        <td className=''>
                            <Input
                                className='px-1'
                                name="upc"
                                placeholder='Barkod...'
                                onChange={e => dispatch(setRollSearchParamsAction({ key: "upc", value: e.target.value }))}
                            />
                        </td>
                        <td className='px-1'>
                            {/* PRODUCT SEARCH */}
                            <CollectionPicker
                                //label='Ürün'
                                //pendingApiCall={pendingApiCallProduct}
                                state={searchParams.collection}
                                setState={(value) => dispatch(setRollSearchParamsAction({ key: 'collection', value }))}
                                query={collectionQuery}
                                setQuery={setCollectionQuery}
                                //error={errors.productId}
                                page={collectionPage}
                                //setErrors={() => setErrors(prevState => ({ ...prevState, productId: undefined }))}
                                //onClickClear={() => setDetail(prevState => ({ ...prevState, product: undefined }))}
                                onClickLoadMore={() => onClickLoadMoreCollection()}
                            />
                        </td>
                        <td className='px-2'>
                            <ColorPicker
                                //label='Ürün'
                                //pendingApiCall={pendingApiCallLocation}
                                state={searchParams.color}
                                setState={(value) => dispatch(setRollSearchParamsAction({ key: 'color', value }))}
                                query={colorQuery}
                                setQuery={setColorQuery}
                                // error={errors.locationId}
                                page={colorPage}
                                //setErrors={() => setErrors(prevState => ({ ...prevState, locationId: undefined }))}
                                //onClickClear={() => setDetail(prevState => ({ ...prevState, product: undefined }))}
                                onClickLoadMore={() => onClickLoadMoreColor()}
                            />
                        </td>
                        <td className='px-2'>
                            <LocationPicker
                                //label='Ürün'
                                //pendingApiCall={pendingApiCallLocation}
                                state={searchParams.location}
                                setState={(value) => dispatch(setRollSearchParamsAction({ key: 'location', value }))}
                                query={locationQuery}
                                setQuery={setLocationQuery}
                                // error={errors.locationId}
                                page={locationPage}
                                //setErrors={() => setErrors(prevState => ({ ...prevState, locationId: undefined }))}
                                //onClickClear={() => setDetail(prevState => ({ ...prevState, product: undefined }))}
                                onClickLoadMore={() => onClickLoadMoreLocation()}
                            />
                        </td>
                        <td className='px-2'>
                            <Input
                                name="boilerCode"
                                placeholder='Kazan no...'
                                onChange={e => dispatch(setRollSearchParamsAction({ key: e.target.name, value: e.target.value }))}
                            />
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr className='border-b items-center text-sm hover:bg-violet-100 duration-150 bg-zinc-200'>
                        <td className='py-2'>TOPLAM</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>{formatNumber(sum?.quantity.toFixed(2))} m</td>
                        <td>{formatNumber(sum?.restQuantity.toFixed(2))} m</td>
                        <td></td>
                    </tr>
                    {
                        rollPage.content.map((roll, index) => (
                            <tr key={index} className='border-b items-center text-sm hover:bg-violet-100 duration-150'>
                                <td className='py-2'>
                                    <input
                                        type='checkbox'
                                        onChange={(e) => onClickSelectBarcode(e.target.checked, roll)}
                                        checked={selectedRolls.filter(r => r.id === roll.id).length > 0}
                                    />
                                </td>

                                <td className='py-2'>{roll.upc} </td>
                                <td className='py-2'><CollectionLabel state={roll.product} /> </td>
                                <td className='py-2'>{roll.product.color ? `${roll.product.color.code}, ${roll.product.color.name}` : ""} </td>
                                <td className='py-2'>{roll.location.name} </td>
                                <td className='py-2'>{roll.boilerCode} </td>
                                <td className='p-2'>{formatNumber(roll.quantity)} m</td>
                                <td className='py-2'>{formatNumber(roll.restQuantity)} m</td>
                                {/* <td className='py-2'>{roll.unitCost}</td> */}
                                <td className='p-2 items-center'>
                                    <div className='flex gap-x-3'>
                                        <span className='cursor-pointer hover:scale-125 hover:text-blue-600 duration-150' onClick={() => nav(`/stock/edit/${roll.id}`)}>
                                            <AiFillEdit />
                                        </span>
                                        <span
                                            className='cursor-pointer hover:scale-125 hover:text-red-600 duration-150'
                                            onClick={() => {
                                                setIsOpen(true)
                                                setDeleteId(roll.id)
                                            }}
                                        >
                                            <AiFillDelete />
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
            <LoadMore page={rollPage} pending={pendingApiCall} onLoadMore={onLoadMore} />
            <DeleteModal
                isOpen={isOpen}
                closeModal={() => setIsOpen(false)}
                onClick={onClickDeleteRoll}
            />
        </div>
    )
}

export default StockListPage